YP.CrmContactCampaign = () => {
  const contactCounter = $('.contact-nb');
  const contactLoader = $('.contact-nb-loader');
  let mainContainer;

  const setMainContainer = (container) => {
    mainContainer = container;
  };

  const init = () => {
    this.filters = [];
    initForm();
    mainContainer = $('.form-newsletter-contact');

    mainContainer.on('change', 'input', { klass: this }, countContact);
    mainContainer.on('change', '.saved_contact_search select', { klass: this }, countContact);
    mainContainer.on('change', '#send_info_campaign_json_contact', { klass: this }, countContact);

    if ($('#send_info_campaign_new_contact').prop('checked')) {
      YP.HandsontableManager().initContactManager();
      $('.save-contact').show();
    }
    if ($('.handsontable-exhibit-account-invitation-js').length) {
      const { invitationMode, ticketTypes } = $('.handsontable-exhibit-account-invitation-js').data();
      YP.HandsontableManager().initExhibitContactManager(invitationMode, ticketTypes);
    }

    mainContainer.on('keypress', function(e) {
      if (e.which == 13) {
        return false;
      }
    });
  };

  const initForm = () => {
    $('#send_info_campaign_all').change(function(e) {
      if ($(this).prop('checked')) {
        $('.js-newsletter-group-container input[type="checkbox"]').prop('checked', false);
      }
    });

    $('.js-newsletter-group-container input[type="checkbox"]').change(function(e) {
      if ($(this).prop('checked')) {
        $('#send_info_campaign_all').prop('checked', false);
      }
    });

    $('#send_info_campaign_new_contact').change(function(e) {
      if ($(this).prop('checked')) {
        $('.handsontable_selector').show();
        if ($('.handsontable').length === 0) {
          YP.HandsontableManager().initContactManager();
        }
      } else {
        $('.handsontable_selector').hide();
      }
    });

    $('#send_info_campaign_save_contact').change(function(e) {
      if ($(this).prop('checked')) {
        $('#send_info_campaign_save_contact_name').show();
      } else {
        $('#send_info_campaign_save_contact_name').hide();
      }
    });

    $('.c-form_js-exhibit-contact').on('submit', function(e) {
      const form = $(this);
      const btnAction = form.find('button:submit');
      btnAction.prop('disabled', true);
    });
  };

  const countContact = ({ data: { klass } }) => {
    contactLoader.show();
    const needToDisable = !$('#btn-submit-contacts').prop('disabled');
    if (needToDisable) {
      $('#btn-submit-contacts').prop('disabled', true);
    }
    $('.js-handsontable-helper .s-loader').show();

    const formData = new FormData(mainContainer[0]);
    $.ajax({
      type: 'POST',
      url: mainContainer.data('urlcount'),
      data: formData,
      dataType: 'json',
      processData: false,
      contentType: false,
      success: function(data) {
        $('.js-handsontable-helper .s-loader').hide();
        contactCounter.html(data.count);
        if (data.unFollowContactIds) {
          $('.unfollowIds').show();
          $('.unfollowIds .contact-nb').html(data.unFollowContactIds);
        } else {
          $('.unfollowIds').hide();
          $('.unfollowIds .contact-nb').html(0);
        }
        contactLoader.hide();
        if (data.error) {
          $.each(data.error, function(index, value) {
            const container = $(`input[name="${index}"]`).parents('.c-form__line');
            container.addClass('c-form__line_error c-form__line_error-js');
            container.find('.c-form__info_error').html(value);
          });
        } else {
          $('.c-form__line_error-js').removeClass('c-form__line_error c-form__line_error-js');
        }

        if (needToDisable) {
          $('#btn-submit-contacts').prop('disabled', false);
        }
        checkMailFeature(data);
      },
    });
  };

  const checkMailFeature = (data) => {
    const count = Number($('.progressbar_contact').data('email')) + data.count;
    let percent = Math.max(count / Number($('.progressbar_contact').data('limit')) * 100);
    percent = percent > 100 ? 100 : percent;
    const color = percent >= 100 ? 'orange' : 'green';

    $('.counter-contact').html(count);
    $('.progressbar_contact').width(`${percent}%`);
    $('.progressbar_contact').attr('class', `progressbar_contact c-progressbar__content_color_${color} c-progressbar__content`);

    if (percent >= 100) {
      $('.c-msg-box-count-contact').show();
    } else {
      $('.c-msg-box-count-contact').hide();
    }

    $('#btn-submit-contacts').prop('disabled', false).removeClass('c-btn--disabled');
  };

  return {
    setMainContainer,
    init,
    checkMailFeature,
  };
};

$(() => {
  if ($('.form-newsletter-contact').length) {
    YP.CrmContactCampaign().init();
  }
});